import { getReferenceDetailPath } from "../../../core/schema/paths/getReferenceDetailPath.js";
import type { Reference } from "../../../core/schema/Reference.js";
import type { CardItem } from "./ArticleCardProps.js";

export function referenceToCard(reference: Reference): CardItem {
	return {
		title: reference.title,
		perex: reference.perex,
		primaryImage: reference.previewImage ?? reference.images[0],
		href: `/${getReferenceDetailPath(reference)}`,
		hasBadge: true,
	};
}
